import { render, staticRenderFns } from "./FormConfiguracionCuentasContables.vue?vue&type=template&id=6d8a52b0&scoped=true&"
import script from "./FormConfiguracionCuentasContables.vue?vue&type=script&lang=js&"
export * from "./FormConfiguracionCuentasContables.vue?vue&type=script&lang=js&"
import style0 from "./FormConfiguracionCuentasContables.vue?vue&type=style&index=0&id=6d8a52b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a52b0",
  null
  
)

export default component.exports